import React, { useEffect } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة الخرسانة - حساب وتقدير كمية وتكلفة الخرسانة";
const DESCRIPTION = " حاسبة الخرسانة هي أداة رقمية تساعد في تقدير كمية الخرسانة اللازمة لمشروع بناء معين، حيث يتم إدخال أبعاد المشروع مثل الطول والعرض والسمك، وتقوم الآلة بحساب حجم الخرسانة المطلوب، بالإضافة إلى تقدير وزن الخرسانة وتكلفة المواد، مما يسهل عملية التخطيط والبناء.";
const KEYWORDS = "برنامج حساب كمية الخرسانة، مكونات متر مكعب خرسانة، كيفية حساب سعر متر الخرسانة، كم كيس اسمنت في المتر المكعب خرسانة";
const OG_URL = "https://do-calculate.com/حاسبة_الخرسانة/";
const Calculator = () => {
  useEffect(() => {
    // Concrete Calculator JavaScript logic
    window.concreteCalc = {
      isNumber(val) {
        val = val + "";
        if (val.length < 1) return false;
        if (isNaN(val)) {
          return false;
        } else {
          return true;
        }
      },
      showquickobjmsg(C, B, A) {
        const element = document.getElementById(A);
        if (element) {
          if (B) {
            C = "<span style='color: #dc3545; font-weight: 600;'>" + C + "</span>";
          }
          element.innerHTML = C;
        }
      },
      calcslab(A) {
        const th = document.getElementById("slablength")?.value?.trim() || "";
        const SG = document.getElementById("slablengthunit")?.value?.trim() || "";
        const NP = document.getElementById("slabwidth")?.value?.trim() || "";
        const gd = document.getElementById("slabwidthunit")?.value?.trim() || "";
        const IB = document.getElementById("slabthick")?.value?.trim() || "";
        const gE = document.getElementById("slabthickunit")?.value?.trim() || "";
        const KR = document.getElementById("slabquantity")?.value?.trim() || "";
        if (!this.isNumber(th)) {
          this.showquickobjmsg("الطول يجب أن يكون رقم", true, A);
          return;
        } else if (!this.isNumber(NP)) {
          this.showquickobjmsg("العرض يجب أن يكون رقم", true, A);
          return;
        } else if (!this.isNumber(IB)) {
          this.showquickobjmsg("الثخانة يجب أن تكون رقم", true, A);
          return;
        } else if (!this.isNumber(KR)) {
          this.showquickobjmsg("الكمية يجب أن تكون رقم", true, A);
          return;
        }
        let length = parseFloat(th);
        let width = parseFloat(NP);
        let thick = parseFloat(IB);
        const quantity = parseFloat(KR);
        if (length < 0 || width < 0 || thick < 0 || quantity < 0) {
          this.showquickobjmsg("جميع الأرقام يجب أن تكون موجبة", true, A);
          return;
        }
        // Convert to meters
        if (SG == "foot") length = length * 0.3048;
        else if (SG == "inch") length = length * 0.0254;
        else if (SG == "yard") length = length * 0.9144;
        else if (SG == "centimeter") length = length * 0.01;
        if (gd == "foot") width = width * 0.3048;
        else if (gd == "inch") width = width * 0.0254;
        else if (gd == "yard") width = width * 0.9144;
        else if (gd == "centimeter") width = width * 0.01;
        if (gE == "foot") thick = thick * 0.3048;
        else if (gE == "inch") thick = thick * 0.0254;
        else if (gE == "yard") thick = thick * 0.9144;
        else if (gE == "centimeter") thick = thick * 0.01;
        const ET = length * width * thick * quantity;
        const gA = ET / 0.3048 / 0.3048 / 0.3048;
        const PP = ET / 0.9144 / 0.9144 / 0.9144;
        const bQ = ET * 2130;
        const vH = gA * 133;
        let ko = "<div style='background: linear-gradient(135deg, #d1f4e0 0%, #b8f0d0 100%); padding: 20px; border-radius: 12px; border-right: 4px solid #1a5f3f; margin-top: 15px;'>";
        ko += "<h3 style='color: #1a5f3f; font-weight: 700; margin-bottom: 15px; font-size: 18px;'>النتائج:</h3>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'><strong style='color: #1a5f3f;'>" + gA.toPrecision(3) + "</strong> قدم مكعب</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'>أو <strong style='color: #1a5f3f;'>" + PP.toPrecision(3) + "</strong> ياردة مكعبة</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'>أو <strong style='color: #1a5f3f;'>" + ET.toPrecision(3) + "</strong> متر مكعب</p>";
        ko += "<hr style='border-top: 1px solid rgba(26, 95, 63, 0.2); margin: 15px 0;'>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>إذا كان الخرسانة مسبقة الخلط*، فإنه يكون <strong style='color: #1a5f3f;'>" + vH.toPrecision(3) + "</strong> أرطال</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>أو <strong style='color: #1a5f3f;'>" + bQ.toPrecision(3) + "</strong> كجم</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>إذا كانت 60 رطل لكل كيس، فإنها تكون <strong style='color: #1a5f3f;'>" + (vH / 60).toPrecision(3) + "</strong> أكياس</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>إذا كانت 80 رطل لكل كيس، فإنها تكون <strong style='color: #1a5f3f;'>" + (vH / 80).toPrecision(3) + "</strong> أكياس</p>";
        ko += "</div>";
        this.showquickobjmsg(ko, false, A);
      },
      calchole(A) {
        const wG = document.getElementById("holediameter")?.value?.trim() || "";
        const kK = document.getElementById("holediameterunit")?.value?.trim() || "";
        const Mh = document.getElementById("holedepth")?.value?.trim() || "";
        const GR = document.getElementById("holedepthunit")?.value?.trim() || "";
        const Ff = document.getElementById("holequantity")?.value?.trim() || "";
        if (!this.isNumber(wG)) {
          this.showquickobjmsg("القطر يجب أن يكون رقميًا", true, A);
          return;
        } else if (!this.isNumber(Mh)) {
          this.showquickobjmsg("العمق أو الارتفاع يجب أن يكون رقميًا", true, A);
          return;
        } else if (!this.isNumber(Ff)) {
          this.showquickobjmsg("الكمية يجب أن تكون رقمية", true, A);
          return;
        }
        let diameter = parseFloat(wG);
        let depth = parseFloat(Mh);
        const quantity = parseFloat(Ff);
        if (diameter < 0 || depth < 0 || quantity < 0) {
          this.showquickobjmsg("يجب أن تكون جميع الأرقام موجبة", true, A);
          return;
        }
        // Convert to meters
        if (kK == "foot") diameter = diameter * 0.3048;
        else if (kK == "inch") diameter = diameter * 0.0254;
        else if (kK == "yard") diameter = diameter * 0.9144;
        else if (kK == "centimeter") diameter = diameter * 0.01;
        if (GR == "foot") depth = depth * 0.3048;
        else if (GR == "inch") depth = depth * 0.0254;
        else if (GR == "yard") depth = depth * 0.9144;
        else if (GR == "centimeter") depth = depth * 0.01;
        const ET = (depth * 3.14159 * diameter * diameter * quantity) / 4;
        const gA = ET / 0.3048 / 0.3048 / 0.3048;
        const PP = ET / 0.9144 / 0.9144 / 0.9144;
        const bQ = ET * 2130;
        const vH = gA * 133;
        let ko = "<div style='background: linear-gradient(135deg, #d1f4e0 0%, #b8f0d0 100%); padding: 20px; border-radius: 12px; border-right: 4px solid #1a5f3f; margin-top: 15px;'>";
        ko += "<h3 style='color: #1a5f3f; font-weight: 700; margin-bottom: 15px; font-size: 18px;'>النتائج:</h3>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'><strong style='color: #1a5f3f;'>" + gA.toPrecision(3) + "</strong> قدم مكعب</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'>أو <strong style='color: #1a5f3f;'>" + PP.toPrecision(3) + "</strong> ياردة مكعبة</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'>أو <strong style='color: #1a5f3f;'>" + ET.toPrecision(3) + "</strong> متر مكعب</p>";
        ko += "<hr style='border-top: 1px solid rgba(26, 95, 63, 0.2); margin: 15px 0;'>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>إذا كان الخرسانة مسبقة الخلط*، فإنه يكون <strong style='color: #1a5f3f;'>" + vH.toPrecision(3) + "</strong> أرطال</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>أو <strong style='color: #1a5f3f;'>" + bQ.toPrecision(3) + "</strong> كجم</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>إذا كانت 60 رطل لكل كيس، فإنها تكون <strong style='color: #1a5f3f;'>" + (vH / 60).toPrecision(3) + "</strong> أكياس</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>إذا كانت 80 رطل لكل كيس، فإنها تكون <strong style='color: #1a5f3f;'>" + (vH / 80).toPrecision(3) + "</strong> أكياس</p>";
        ko += "</div>";
        this.showquickobjmsg(ko, false, A);
      },
      calctube(A) {
        const OJ = document.getElementById("tubediameter")?.value?.trim() || "";
        const ZN = document.getElementById("tubediameterunit")?.value?.trim() || "";
        const cT = document.getElementById("tubeindiameter")?.value?.trim() || "";
        const KQ = document.getElementById("tubeindiameterunit")?.value?.trim() || "";
        const lf = document.getElementById("tubedepth")?.value?.trim() || "";
        const WL = document.getElementById("tubedepthunit")?.value?.trim() || "";
        const lY = document.getElementById("tubequantity")?.value?.trim() || "";
        if (!this.isNumber(OJ)) {
          this.showquickobjmsg("القطر الخارجي يجب أن يكون رقم", true, A);
          return;
        } else if (!this.isNumber(cT)) {
          this.showquickobjmsg("القطر الداخلي يجب أن يكون رقم", true, A);
          return;
        } else if (!this.isNumber(lf)) {
          this.showquickobjmsg("الطول أو الارتفاع يجب أن يكون رقم", true, A);
          return;
        } else if (!this.isNumber(lY)) {
          this.showquickobjmsg("الكمية يجب أن تكون رقم", true, A);
          return;
        }
        let outerD = parseFloat(OJ);
        let innerD = parseFloat(cT);
        let length = parseFloat(lf);
        const quantity = parseFloat(lY);
        if (outerD < 0 || innerD < 0 || length < 0 || quantity < 0) {
          this.showquickobjmsg("جميع الأرقام يجب أن تكون موجبة", true, A);
          return;
        }
        if (outerD < innerD) {
          this.showquickobjmsg("القطر الداخلي يجب أن يكون أصغر من القطر الخارجي", true, A);
          return;
        }
        // Convert to meters
        if (ZN == "foot") outerD = outerD * 0.3048;
        else if (ZN == "inch") outerD = outerD * 0.0254;
        else if (ZN == "yard") outerD = outerD * 0.9144;
        else if (ZN == "centimeter") outerD = outerD * 0.01;
        if (KQ == "foot") innerD = innerD * 0.3048;
        else if (KQ == "inch") innerD = innerD * 0.0254;
        else if (KQ == "yard") innerD = innerD * 0.9144;
        else if (KQ == "centimeter") innerD = innerD * 0.01;
        if (WL == "foot") length = length * 0.3048;
        else if (WL == "inch") length = length * 0.0254;
        else if (WL == "yard") length = length * 0.9144;
        else if (WL == "centimeter") length = length * 0.01;
        const ET = (length * 3.14159 * (outerD * outerD - innerD * innerD) * quantity) / 4;
        const gA = ET / 0.3048 / 0.3048 / 0.3048;
        const PP = ET / 0.9144 / 0.9144 / 0.9144;
        const bQ = ET * 2130;
        const vH = gA * 133;
        let ko = "<div style='background: linear-gradient(135deg, #d1f4e0 0%, #b8f0d0 100%); padding: 20px; border-radius: 12px; border-right: 4px solid #1a5f3f; margin-top: 15px;'>";
        ko += "<h3 style='color: #1a5f3f; font-weight: 700; margin-bottom: 15px; font-size: 18px;'>النتائج:</h3>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'><strong style='color: #1a5f3f;'>" + gA.toPrecision(3) + "</strong> قدم مكعب</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'>أو <strong style='color: #1a5f3f;'>" + PP.toPrecision(3) + "</strong> ياردة مكعبة</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 16px;'>أو <strong style='color: #1a5f3f;'>" + ET.toPrecision(3) + "</strong> متر مكعب</p>";
        ko += "<hr style='border-top: 1px solid rgba(26, 95, 63, 0.2); margin: 15px 0;'>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>إذا كان الخرسانة مسبقة الخلط*، فإنه يكون <strong style='color: #1a5f3f;'>" + vH.toPrecision(3) + "</strong> أرطال</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>أو <strong style='color: #1a5f3f;'>" + bQ.toPrecision(3) + "</strong> كجم</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>إذا كانت 60 رطل لكل كيس، فإنها تكون <strong style='color: #1a5f3f;'>" + (vH / 60).toPrecision(3) + "</strong> أكياس</p>";
        ko += "<p style='margin: 10px 0; color: #0f3d28; font-size: 15px;'>إذا كانت 80 رطل لكل كيس، فإنها تكون <strong style='color: #1a5f3f;'>" + (vH / 80).toPrecision(3) + "</strong> أكياس</p>";
        ko += "</div>";
        this.showquickobjmsg(ko, false, A);
      }
    };
    // Cleanup
    return () => {
      delete window.concreteCalc;
    };
  }, []);
  const handleCalcSlab = () => {
    if (window.concreteCalc) {
      window.concreteCalc.calcslab('coutputslab');
    }
  };
  const handleCalcHole = () => {
    if (window.concreteCalc) {
      window.concreteCalc.calchole('coutputhole');
    }
  };
  const handleCalcTube = () => {
    if (window.concreteCalc) {
      window.concreteCalc.calctube('coutputtube');
    }
  };
  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@300;400;500;700;900&family=IBM+Plex+Sans+Arabic:wght@300;400;500;600;700&display=swap');
          .concrete-calc-container {
            font-family: 'IBM Plex Sans Arabic', 'Tajawal', sans-serif;
          }
          .concrete-calc-section {
            background: #ffffff;
            border-radius: 12px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 4px 12px rgba(26, 95, 63, 0.08);
          }
          .concrete-calc-header {
            background: linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%);
            color: #ffffff;
            padding: 15px 20px;
            border-radius: 12px;
            margin-bottom: 20px;
            box-shadow: 0 4px 12px rgba(26, 95, 63, 0.25);
          }
          .concrete-calc-header h2 {
            font-size: 18px;
            font-weight: 700;
            margin: 0;
            color: #ffffff;
          }
          .concrete-calc-table {
            width: 100%;
            background: #fafbf8;
            border-radius: 12px;
            padding: 20px;
          }
          .concrete-calc-row {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            gap: 15px;
          }
          .concrete-calc-label {
            flex: 0 0 120px;
            font-weight: 600;
            color: #1a5f3f;
            font-size: 15px;
          }
          .concrete-calc-input {
            flex: 1;
            padding: 12px 16px;
            border: 2px solid #e2e8f0;
            border-radius: 10px;
            font-size: 16px;
            text-align: right;
            background: #ffffff;
            font-family: 'Tajawal', sans-serif;
          }
          .concrete-calc-input:focus {
            outline: none;
            border-color: #1a5f3f;
            box-shadow: 0 0 0 3px rgba(26, 95, 63, 0.1);
          }
          .concrete-calc-select {
            flex: 0 0 140px;
            padding: 12px 16px;
            border: 2px solid #e2e8f0;
            border-radius: 10px;
            font-size: 15px;
            background: #ffffff;
            font-family: 'Tajawal', sans-serif;
            cursor: pointer;
          }
          .concrete-calc-select:focus {
            outline: none;
            border-color: #1a5f3f;
            box-shadow: 0 0 0 3px rgba(26, 95, 63, 0.1);
          }
          .concrete-calc-button {
            width: 100%;
            padding: 14px 24px;
            background: linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%);
            color: #ffffff;
            border: none;
            border-radius: 12px;
            font-size: 20px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(26, 95, 63, 0.25);
            font-family: 'Tajawal', sans-serif;
            margin-top: 20px;
          }
          .concrete-calc-button:hover {
            background: linear-gradient(135deg, #2d8a5f 0%, #3a9f6f 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(26, 95, 63, 0.35);
          }
          .concrete-calc-button:active {
            background: linear-gradient(135deg, #0f3d28 0%, #1a5f3f 100%);
            transform: translateY(0);
            box-shadow: 0 2px 8px rgba(26, 95, 63, 0.3);
          }
          .concrete-calc-footer {
            text-align: center;
            padding: 15px;
            color: #6c757d;
            font-size: 12px;
          }
          .concrete-calc-footer a {
            color: #1a5f3f;
            text-decoration: none;
            font-weight: 600;
          }
          .concrete-calc-footer a:hover {
            color: #2d8a5f;
            text-decoration: underline;
          }
          @media (max-width: 768px) {
            .concrete-calc-row {
              flex-direction: column;
              align-items: stretch;
              gap: 10px;
            }
            .concrete-calc-label {
              flex: none;
            }
            .concrete-calc-select {
              flex: none;
            }
            .concrete-calc-button {
              font-size: 18px;
              padding: 12px 20px;
            }
          }
        `}
      </style>
      <div className="rtl concrete-calc-container">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div className="row">
          <div className="col-sm-12 col-md-10">
            <FirstAds />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-8">
            <br />
            <div
              className="bg-success text-white text-center"
              style={{ height: "60px" }}
            >
              <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
            </div>
            <div className="border border-light">
              <div className="row">
                <div>
                  <p>
                    حاسبة الخرسانة هي أداة رقمية مبتكرة تسهل على المقاولين، المهندسين،
                    وأصحاب المشاريع تحديد كمية الخرسانة التي يحتاجونها بدقة لأي مشروع بناء.
                    سواء كنت تبني منزلًا، تصب أساسًا، أو تقوم بمشروع تجاري كبير، فإن هذه
                    الأداة تساعدك في تقدير الحجم الصحيح للخرسانة، بناءً على إدخال أبعاد
                    محددة مثل الطول، العرض، والسمك.
                  </p>
                  <b>
                    تاريخ آخر تحديث: <time dateTime="2026-01-10">28/02/2026</time>
                  </b>
                  <p>
                    تم انشاء معادلات الحاسبة من قبل مختصين في مجال البناء والهندسة المعمارية، وتم تحديثها بانتظام لتوفير الدقة والموثوقية. يمكنك استخدام هذه الحاسبة لتحديد كمية الخرسانة المطلوبة لأي مشروع بناء، بما في ذلك الأساسات، الجدران، الأعمدة، والأرضيات. ببضع نقرات، يمكنك الحصول على تقدير دقيق للمواد الأساسية مثل الأسمنت، الحصى، الرمل، والماء، وتقليل الهدر وتوفير الوقت والمال.
                  </p>
                </div>
                <hr />
              </div>
              <MobileUnderCalAds />
              {/* Slab Calculator */}
              <div className="concrete-calc-section">
                <div className="concrete-calc-header">
                  <h2>حساب الصفائح، الأساسات المربعة، أو الجدران</h2>
                </div>
                <div className="concrete-calc-table">
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">الطول</div>
                    <input
                      type="text"
                      id="slablength"
                      className="concrete-calc-input"
                      defaultValue="2.5"
                    />
                    <select id="slablengthunit" className="concrete-calc-select">
                      <option value="foot">قدم</option>
                      <option value="inch">بوصة</option>
                      <option value="yard">ياردة</option>
                      <option value="meter" selected>متر</option>
                      <option value="centimeter">سنتيمتر</option>
                    </select>
                  </div>
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">العرض</div>
                    <input
                      type="text"
                      id="slabwidth"
                      className="concrete-calc-input"
                      defaultValue="5"
                    />
                    <select id="slabwidthunit" className="concrete-calc-select">
                      <option value="foot">قدم</option>
                      <option value="inch">بوصة</option>
                      <option value="yard">ياردة</option>
                      <option value="meter" selected>متر</option>
                      <option value="centimeter">سنتيمتر</option>
                    </select>
                  </div>
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">الثخانة</div>
                    <input
                      type="text"
                      id="slabthick"
                      className="concrete-calc-input"
                      defaultValue="5"
                    />
                    <select id="slabthickunit" className="concrete-calc-select">
                      <option value="foot">قدم</option>
                      <option value="inch">بوصة</option>
                      <option value="yard">ياردة</option>
                      <option value="meter">متر</option>
                      <option value="centimeter" selected>سنتيمتر</option>
                    </select>
                  </div>
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">الكمية</div>
                    <input
                      type="text"
                      id="slabquantity"
                      className="concrete-calc-input"
                      defaultValue="1"
                    />
                  </div>
                  <button className="concrete-calc-button" onClick={handleCalcSlab}>
                    احسب
                  </button>
                  <div id="coutputslab" style={{ marginTop: '15px' }}></div>
                </div>
              </div>
              {/* Hole Calculator */}
              <div className="concrete-calc-section">
                <div className="concrete-calc-header">
                  <h2>حساب الفتحة، العمود، أو القواعد الدائرية</h2>
                </div>
                <div className="concrete-calc-table">
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">القطر</div>
                    <input
                      type="text"
                      id="holediameter"
                      className="concrete-calc-input"
                      defaultValue="2.5"
                    />
                    <select id="holediameterunit" className="concrete-calc-select">
                      <option value="foot">قدم</option>
                      <option value="inch">بوصة</option>
                      <option value="yard">ياردة</option>
                      <option value="meter" selected>متر</option>
                      <option value="centimeter">سنتيمتر</option>
                    </select>
                  </div>
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">العمق أو الطول</div>
                    <input
                      type="text"
                      id="holedepth"
                      className="concrete-calc-input"
                      defaultValue="6"
                    />
                    <select id="holedepthunit" className="concrete-calc-select">
                      <option value="foot">قدم</option>
                      <option value="inch">بوصة</option>
                      <option value="yard">ياردة</option>
                      <option value="meter">متر</option>
                      <option value="centimeter" selected>سنتيمتر</option>
                    </select>
                  </div>
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">الكمية</div>
                    <input
                      type="text"
                      id="holequantity"
                      className="concrete-calc-input"
                      defaultValue="1"
                    />
                  </div>
                  <button className="concrete-calc-button" onClick={handleCalcHole}>
                    احسب
                  </button>
                  <div id="coutputhole" style={{ marginTop: '15px' }}></div>
                </div>
              </div>
              {/* Tube Calculator */}
              <div className="concrete-calc-section">
                <div className="concrete-calc-header">
                  <h2>حساب اللوح الدائري</h2>
                </div>
                <div className="concrete-calc-table">
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">القطر الخارجي</div>
                    <input
                      type="text"
                      id="tubediameter"
                      className="concrete-calc-input"
                      defaultValue="5"
                    />
                    <select id="tubediameterunit" className="concrete-calc-select">
                      <option value="foot">قدم</option>
                      <option value="inch">بوصة</option>
                      <option value="yard">ياردة</option>
                      <option value="meter" selected>متر</option>
                      <option value="centimeter">سنتيمتر</option>
                    </select>
                  </div>
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">القطر الداخلي</div>
                    <input
                      type="text"
                      id="tubeindiameter"
                      className="concrete-calc-input"
                      defaultValue="4"
                    />
                    <select id="tubeindiameterunit" className="concrete-calc-select">
                      <option value="foot">قدم</option>
                      <option value="inch">بوصة</option>
                      <option value="yard">ياردة</option>
                      <option value="meter" selected>متر</option>
                      <option value="centimeter">سنتيمتر</option>
                    </select>
                  </div>
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">الطول</div>
                    <input
                      type="text"
                      id="tubedepth"
                      className="concrete-calc-input"
                      defaultValue="5"
                    />
                    <select id="tubedepthunit" className="concrete-calc-select">
                      <option value="foot">قدم</option>
                      <option value="inch">بوصة</option>
                      <option value="yard">ياردة</option>
                      <option value="meter">متر</option>
                      <option value="centimeter" selected>سنتيمتر</option>
                    </select>
                  </div>
                  <div className="concrete-calc-row">
                    <div className="concrete-calc-label">الكمية</div>
                    <input
                      type="text"
                      id="tubequantity"
                      className="concrete-calc-input"
                      defaultValue="1"
                    />
                  </div>
                  <button className="concrete-calc-button" onClick={handleCalcTube}>
                    احسب
                  </button>
                  <div id="coutputtube" style={{ marginTop: '15px' }}></div>
                </div>
              </div>
              <hr />
              <div className="row">
                <RelatedLinks />
                <hr style={{ width: "100%" }} />
              </div>
            </div>
          </div>
          <div className="col">
            <SecondAds />
            <br />
            <MainCalculatorsList></MainCalculatorsList>
            <br />
          </div>
        </div>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>حاسبة الخرسانة</h3>
              </div>
              <div className="info-section-body">
                <p>
                  حاسبة الخرسانة هي أداة ضرورية لأي شخص يعمل في قطاع البناء، سواء كنت مقاولاً محترفًا أو شخصًا يقوم بمشروع صغير في المنزل. تتيح هذه الأداة للمستخدمين حساب كمية الخرسانة المطلوبة بدقة عالية، مما يقلل من التكاليف المهدورة ويضمن عدم شراء كمية إضافية أو نقص في المواد.
                </p>
                <h4>كيفية استخدام حاسبة الخرسانة:</h4>
                <ol>
                  <li>
                    <strong>إدخال الأبعاد:</strong> ابدأ بإدخال أبعاد المنطقة التي سيتم صب الخرسانة فيها، مثل الطول، العرض، والسمك (الارتفاع). تقوم الحاسبة بعد ذلك بحساب الحجم المطلوب بناءً على هذه الأبعاد.
                  </li>
                  <li>
                    <strong>اختيار نوع الخليط:</strong> يمكنك تخصيص الحاسبة لتناسب المشروع الخاص بك عن طريق اختيار نوع الخرسانة الذي تحتاجه (مثل خليط خرسانة مقاومة أو خفيفة الوزن). بعض المشاريع قد تتطلب خرسانة مع نسب مختلفة من المواد.
                  </li>
                  <li>
                    <strong>الحصول على النتائج:</strong> فور إدخال البيانات، ستعرض لك الحاسبة حجم الخرسانة المطلوب بالمتر المكعب، بالإضافة إلى تقدير كمية المواد الأساسية (الأسمنت، الحصى، الرمل، والماء).
                  </li>
                </ol>
                <h4>مزايا استخدام حاسبة الخرسانة:</h4>
                <ul>
                  <li>
                    <strong>الدقة في الحساب:</strong> توفر الحاسبة دقة فائقة في تحديد كمية الخرسانة المطلوبة، مما يقلل من الهدر ويوفر المال والوقت.
                  </li>
                  <li>
                    <strong>تقدير التكاليف:</strong> بناءً على الأسعار المحلية للمواد، يمكن للحاسبة أيضًا تقديم تقديرات للتكاليف النهائية، مما يسهل عملية وضع الميزانية للمشروع.
                  </li>
                  <li>
                    <strong>التخصيص لمختلف المشاريع:</strong> سواء كنت تقوم ببناء جدران، أعمدة، أو أساسات، فإن حاسبة الخرسانة تناسب جميع أنواع المشاريع الإنشائية وتوفر خيارات متعددة لحساب المواد.
                  </li>
                  <li>
                    <strong>تقليل الأخطاء:</strong> الاعتماد على الحساب اليدوي قد يؤدي إلى أخطاء تؤثر على كفاءة المشروع. باستخدام الحاسبة الرقمية، تضمن تقليل الأخطاء وزيادة فعالية التنفيذ.
                  </li>
                </ul>
                <h4>أمثلة عملية لاستخدام حاسبة الخرسانة:</h4>
                <ul>
                  <li>
                    <strong>أساسات مبنى:</strong> إذا كنت تبني أساسًا بمساحة 200 متر مربع وسمك 0.3 متر، فإن الحاسبة ستحسب كمية الخرسانة المطلوبة بحوالي 60 متر مكعب. كما ستخبرك الحاسبة بكمية الأسمنت والرمل والمواد الأخرى اللازمة.
                  </li>
                  <li>
                    <strong>صب السقف الخرساني:</strong> لبناء سقف بمساحة 120 متر مربع وسمك 0.15 متر، ستحسب الحاسبة أن كمية الخرسانة المطلوبة هي 18 متر مكعب، مع تقدير دقيق للمواد المطلوبة.
                  </li>
                  <li>
                    <strong>أعمدة خرسانية لمبنى:</strong> إذا كنت بحاجة إلى صب 10 أعمدة بارتفاع 3 أمتار وقطر 0.5 متر، ستقوم الحاسبة بحساب الحجم المطلوب بدقة لكل عمود وإجمالي المواد اللازمة.
                  </li>
                </ul>
                <h4>نصائح مهمة عند استخدام حاسبة الخرسانة:</h4>
                <ul>
                  <li>
                    <strong>التحقق من الأبعاد:</strong> تأكد من قياس الأبعاد بدقة قبل إدخالها في الحاسبة للحصول على نتائج صحيحة. يجب أن تكون الدقة عالية لتفادي الهدر.
                  </li>
                  <li>
                    <strong>معرفة نوع الخرسانة المطلوبة:</strong> تأكد من تحديد نوع الخرسانة المناسب لمشروعك، سواء كنت تحتاج إلى خرسانة قوية للأساسات أو خرسانة خفيفة للأعمدة.
                  </li>
                  <li>
                    <strong>أخذ هامش احتياطي:</strong> من الجيد دائمًا إضافة هامش صغير عند حساب الخرسانة المطلوبة للتعويض عن أي تقلبات أو ظروف غير متوقعة.
                  </li>
                </ul>
                <p>
                  في النهاية، فإن حاسبة الخرسانة تساعد على ضمان سير مشروع البناء الخاص بك بكفاءة عالية وبدون أي مفاجآت غير مرغوبة. باستخدام هذه الأداة الرقمية، يمكنك التخطيط بدقة وتجنب الأخطاء التي قد تكلفك المزيد من المال والوقت في المستقبل.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Calculator;